'use strict';

const braintreeClient = require('braintree-web/client');
const braintreeHostedFields = require('braintree-web/hosted-fields');

angular.module('cgmemApp')
	.factory('BrainTree', ['$http', '$log', 'Logger', function ($http, $log, Logger) {
		var api = {};
		var hfi = null;
		api.init = function (formId, hostedFieldsConfig, onError, onPaymentMethodReceived) {
			return $http.get('/api/transactions/client_token')
				.then(function (data) {
					var clientToken = data.data;

					return braintreeClient.create({
						authorization: clientToken
					})
				})
				.then(clientInstance => {
					return braintreeHostedFields.create({
						client: clientInstance,
						fields: hostedFieldsConfig.fields,
						styles: hostedFieldsConfig.styles
					});
				}).then(function (hostedFieldsInstance) {
					// Make tokenize call on form submission
					hfi = hostedFieldsInstance;
					var form = document.querySelector(formId);
					if(!form)
						throw new Error('No credit card form present');
					form.addEventListener('submit', function (event) {
						event.preventDefault();

						hostedFieldsInstance.tokenize()
							.then(payload => {
								// Submit payload.nonce to your server
								return onPaymentMethodReceived(payload);
							})
							.catch(error => {
								$log.log('Tokenize error', error)
								return onError(error);
							})
					}, false);
				});
		}
		api.teardown = function() {
			if(hfi) {
				hfi.teardown()
				.catch( err => {
					return $log.log('Teardown error:', err);
				})
			}
		}
		return api;
	}]);
